import React, { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { ContextToggle } from '@/components/ContextToggle';
import { Wheel } from '@/components/Wheel';
import { CategoryResultCard } from '@/components/CategoryResultCard';
import { Footer } from '@/components/Footer';
import { Button } from '@/components/ui/button';
import { useSkillRotation } from '@/hooks/useSkillRotation';

export const DemoPage = () => {
  const navigate = useNavigate();
  const { getNextSkill } = useSkillRotation();
  
  const [context, setContext] = useState('daily_life');
  const [currentCategory, setCurrentCategory] = useState(null);
  const [currentSkillName, setCurrentSkillName] = useState(null);
  const [hasSpun, setHasSpun] = useState(false);

  const handleSpinComplete = useCallback((category) => {
    const skillName = getNextSkill(category);
    setCurrentCategory(category);
    setCurrentSkillName(skillName);
    setHasSpun(true);
  }, [getNextSkill]);

  const handleContextChange = useCallback((newContext) => {
    setContext(newContext);
  }, []);

  const handleResetDemo = useCallback(() => {
    setCurrentCategory(null);
    setCurrentSkillName(null);
    setHasSpun(false);
  }, []);

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <div className="flex-1 w-full max-w-2xl mx-auto px-4 py-6 sm:py-10">
        {/* Context Toggle */}
        <div className="mb-6">
          <ContextToggle 
            value={context} 
            onChange={handleContextChange} 
          />
        </div>

        {/* Instruction */}
        <p className="text-sm text-helper text-center mb-6">
          Pick a context, then spin for one skill to practice today.
        </p>

        {/* Wheel Section - increased bottom margin for spacing */}
        <div className="flex justify-center mb-12">
          <Wheel 
            onSpinComplete={handleSpinComplete}
            disabled={false}
            hasSpunToday={false}
            isDemo={true}
          />
        </div>

        {/* Result Card - the main payoff */}
        {currentCategory && currentSkillName && (
          <div className="w-full max-w-lg mx-auto mb-8 card-animated">
            <CategoryResultCard 
              category={currentCategory}
              skillName={currentSkillName}
              context={context}
              isUsed={false}
              isDemo={true}
            />
          </div>
        )}

        {/* CTA after spin */}
        {hasSpun && (
          <div className="text-center mb-6 card-animated" style={{ animationDelay: '0.15s' }}>
            <Button
              onClick={() => navigate('/wheel')}
              className="px-8 py-3 h-auto text-base font-semibold bg-primary hover:bg-primary-hover text-primary-foreground"
            >
              Ready for your real spin?
            </Button>
            <p className="text-sm text-helper mt-3">
              Your daily spin is waiting.
            </p>
          </div>
        )}

        {/* Spin again option */}
        {hasSpun && (
          <div className="text-center mb-6">
            <Button
              variant="ghost"
              onClick={handleResetDemo}
              className="text-helper hover:text-body"
            >
              Try another demo spin
            </Button>
          </div>
        )}

        {/* Footer */}
        <Footer />
      </div>
    </div>
  );
};

export default DemoPage;
